import { useState, useEffect } from 'react';
import axios from 'axios';

// Which sections the group has switched on. Anything unknown defaults to true,
// so a new flag never hides an existing section until someone turns it off.
const DEFAULTS = {
  featureLoans: true,
  featureExpenses: true,
  featurePenalties: true,
  featureMeetings: true,
  featureSilverDistribution: true,
};

// One shared copy, so flipping a switch in the Admin Panel reaches the sidebar,
// the Rules page and the member ledger without a reload.
let current = { features: DEFAULTS, loaded: false };
let inflight = null;
const listeners = new Set();

const publish = (state) => {
  current = state;
  listeners.forEach((listener) => listener(current));
};

const load = () => {
  if (!inflight) {
    inflight = axios
      .get('/api/rules/features')
      .then((res) => publish({ features: { ...DEFAULTS, ...res.data }, loaded: true }))
      // keep defaults - never hide the app because a call failed
      .catch(() => publish({ features: current.features, loaded: true }));
  }
  return inflight;
};

export const refreshFeatures = () => {
  inflight = null;
  return load();
};

export const useFeatures = () => {
  const [state, setState] = useState(current);

  useEffect(() => {
    listeners.add(setState);
    load();
    return () => { listeners.delete(setState); };
  }, []);

  return state;
};

export default useFeatures;
